import React from 'react';
import isEqual from 'react-fast-compare';

import DataConnector from 'connect/DataConnector';
import {StringIDFolder} from 'constants/FolderConstants';
import * as NavConstants from 'constants/NavConstants';
import {NavStoreProject} from 'constants/SourceConstants';
import * as SidepanelActions from 'nav/sidepanel/SidepanelActions';
import * as SidepanelReduxActions from 'nav/sidepanel/SidepanelReduxActions';
import SidepanelStore from 'nav/sidepanel/SidepanelStore';
import {SearchParams, SortKey} from 'search/SearchConstants';

import ProjectsListing from './ProjectsListing';
import ProjectsSidepanelListing from './ProjectsSidepanelListing';

interface Props {
  activeItemId: string | null;
  isCompactDisplay: boolean;
  setIsCompactDisplay: (isCompact: boolean) => void;
  isExpanded: boolean;
  projects: Array<NavStoreProject>;
  areProjectsLoading: boolean;
}
interface EnhancedProps {
  listedFolder: StringIDFolder | null;
  onListAllSources: () => void;
  onListFolder: (rootFolder: StringIDFolder) => void;
}

class ProjectsSidepanelConnector extends DataConnector<Props, EnhancedProps> {
  stores = [SidepanelStore];

  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  onListFolder = (rootFolder: StringIDFolder, searchParams?: SearchParams) => {
    this.dispatch(SidepanelReduxActions.listFolder(rootFolder, searchParams));
  };

  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  onListAllSources = () => {
    SidepanelActions.listAllSources(NavConstants.Section.PROJECTS);
  };

  enhanceProps(): EnhancedProps {
    const currentSection = this.sidepanelStore().getSection();
    return {
      onListFolder: this.onListFolder,
      onListAllSources: this.onListAllSources,
      listedFolder: currentSection ? this.sidepanelStore().getListedFolder(currentSection) : null,
    };
  }
}

function ProjectsSidepanel(props: Props & EnhancedProps): JSX.Element {
  if (props.listedFolder == null) {
    return (
      <ProjectsListing
        isExpanded={props.isExpanded}
        onListFolder={props.onListFolder}
        availableSortKeys={[SortKey.SORT_NAME_KEY, SortKey.SORT_CREATED_AT_KEY]}
        // TODO(Ben): Remove these properties
        areProjectsLoading={false}
        didLoadingError={false}
        items={[]}
      />
    );
  }

  return (
    <ProjectsSidepanelListing
      isCompactDisplay={props.isCompactDisplay}
      setIsCompactDisplay={props.setIsCompactDisplay}
      isExpanded={props.isExpanded}
      activeItemId={props.activeItemId}
      onNavigateToRoot={props.onListAllSources}
      onOpenFolder={props.onListFolder}
      folder={props.listedFolder}
    />
  );
}

export default ProjectsSidepanelConnector.connect(ProjectsSidepanel, {
  throttleUpdates: true,
  shouldPropagateNextState: (a, b) => !isEqual(a, b),
});
